import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { environment } from "../../../environments/environment";
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { Subscription } from 'rxjs';
import * as _ from 'underscore';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';

declare var google;

@Component({
  selector: 'app-location-tab',
  templateUrl: './location-tab.component.html',
  styleUrls: ['./location-tab.component.scss']
})
export class LocationTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService) { }
  companyDetails: any;
  currentCompanyName: any;
  dataSourceWorkCountry: any[] = [];
  topLocations: any[] = [];
  locations: any = [];
  locationsData: any = [];
  @ViewChild('locationTbSort') locationTbSort: MatSort;
  displayedColumns: string[] = ['key', 'doc_count', 'recent_hires', '%Total', 'graph'];
  aggregatescount: number = 50;
  alternatecompanyNames: any[] = [];

  /** start index in page */
  start: number = 0;
  /**End index in page */
  end: number = 10;
  /**Number of items on each of page */
  pageSize: number = 10;
  /**Current page number */
  currentPage: number = 1;
  /**Total items */
  totalCount = 0;
  locationsubscription: Subscription;
  locationemptystate: Boolean = false;
  totalresultcount: any;
  locationsname: any
  locationSortArr: any = [];
  locationsdataAI: any
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any ={};
  insightsExportSubscription: Subscription = null;

  ngOnInit(): void {
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getTopLocations();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  getTopLocations() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "location-gender-recenthires";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response?.data?.aggregations['location-gender-recenthires'];
      this.locationSortArr = tempData;
      this.formatLocationSortArray();

      this.totalCount = tempData.length;
      this.totalresultcount = response.data.totalresultscount

      this.locationemptystate = true;
      this.locationsname = _.pluck(this.locationSortArr, 'key');

      this.manualSort();
      this.getlocationsAIdata(this.locationSortArr);
    });
  }

  private formatLocationSortArray() {
    this.locationSortArr?.map(apiResponse => {
      if (apiResponse && apiResponse.gender && apiResponse.gender.length > 0) {
        const femalecount = this.getFemaleCount(apiResponse);
        const malecount = this.getMaleCount(apiResponse);
        const totalgendercount = femalecount + malecount;
        apiResponse.female = femalecount ? this.getdiversitypercentage(femalecount, totalgendercount) : 0;
        apiResponse.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount) : 0;
      }
      apiResponse.totalpercentage = apiResponse.doc_count ? this.getlocationpercentage(apiResponse.doc_count) : 0;
      apiResponse.recenthires = apiResponse?.recenthires;
      return apiResponse;
    });
  }

  private getFemaleCount(apiResponse: any) {
    const femaleData = apiResponse?.gender?.find(x => x.key === "female");
    return femaleData?.doc_count || 0;
  }

  private getMaleCount(apiResponse: any) {
    const maleData = apiResponse?.gender?.find(x => x.key === "male");;
    return maleData?.doc_count || 0;
  }

  /**
   * fuction will mark the locations on google map
   * On the basis of data shown on each page
   */
  markMap() {
    const CharForworkCountry = [];
    CharForworkCountry.push(['Location', 'Professional count'])
    this.locationsData.forEach(x => {
      const dataObj = [`${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`, x.doc_count];
      CharForworkCountry.push(dataObj);
    });
    this.dataSourceWorkCountry = CharForworkCountry;
    setTimeout(() => {
      this.loadGoogleMap();
    });
  }

  manualSort() {
    this.reSortArr(this.locationTbSort);
  }

  reSortArr(sort: MatSort) {
    const tempData = this.locationSortArr;
    if (!this.hasSortSelection(sort)) {
      this.setDefaultLocationData(tempData);
      return;
    }
    this.setLocationSortData(tempData, sort);
    this.locationsData = this.locationSortArr.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
    this.locationsname = _.pluck(this.locationSortArr, 'key');
    this.markMap();
  }

  private hasSortSelection(sort: MatSort) {
    return sort && sort.active && sort.direction;
  }

  private setDefaultLocationData(tempData: any) {
    this.locationsData = tempData.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
    this.markMap();
  }

  private setLocationSortData(tempData: any, sort: MatSort) {
    this.locationSortArr = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case '%Total': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.male, b.male, isAsc);
        case 'recent_hires': return this.compare(a.recenthires, b.recenthires, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }


  loadGoogleMap() {
    function drawMarkersMap() {
      var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
      var options = {
        region: 'world',
        displayMode: 'markers',
        colorAxis: { colors: ['#ff7f7f', '#ffff32', '#4292ff'] }
      };
      const container = document.getElementById('workCountryChart');
      var chart = new google.visualization.GeoChart(container);
      chart.draw(data, options);
    }

    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  /**
   * Function set the start and end of aggreggate datat according to page number
   * @param index page number in pagination
   */
  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if (this.aggregatescount / this.pageSize <= index) {
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getTopLocations();
    }
    else {
      this.manualSort();
    }
  }

  /**
   * destroy subscriptions of filters
   */
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getlocationpercentage(value) {
    return ((value / this.totalresultcount) * 100).toFixed(2);
  }


  getdiversitypercentage(value, doc_count) {
    return ((value / doc_count) * 100).toFixed(0);
  }

  /**
     * Handel Redirection to person search listing
     * @param type
     * @param key
     */
  handelRedirection(type: string, key: string) {
    const additionalFilters = {};
    switch (type) {
      case 'location': additionalFilters['mandatorylocations'] = [key]; break;
      case 'recent_hires': {
        additionalFilters['mandatorylocations'] = [key];
        additionalFilters['recentcompanyhires'] = true;
        break;
      }
    }

    this.companyinsightsFilter['additionalFilters'] = additionalFilters;
    this.companyinsightsFilter['name'] = this?.companyDetails?.name;
    this.companyinsightsFilter['alternative_names'] = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, this.companyinsightsFilter);
    const requestObject = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=company-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}&keyword=${requestObject.booleanquery!= '*' ? requestObject.booleanquery: ''}`;
    window.open(url, "_blank");
  }

  getlocationsAIdata(data) {
    let locationsdata: any;
    locationsdata = data.map(x => {
      return {
        'Top Cities': x.key,
        'Talent Count': x.doc_count,
        '% of Total': x.totalpercentage + '%',
        'Male': x.male + '%',
        'Female': x.female + '%',
        'Recent Hires': x.recenthires
      }
    });
    this.locationsdataAI = {
      locations: locationsdata
    }
    if(locationsdata.length == 0)
      this.locationsdataAI = null;
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'location') return;

    const payloadForInsightsExport: ExportPayload = {
      tab: 'location',
      companydetails: this.companyDetails,
      totalresultcount: this.totalresultcount,
      chartdetails: this.dataSourceWorkCountry?.length ? [{ type: 'google', data: this.dataSourceWorkCountry }] : [],
      locationgender: this.locationSortArr,
      location: this.locationSortArr
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
